export default __webpack_public_path__ + "img/d31ac98878160bda0d89b39b8482ae33.jpg";